{
    "overview__today_sales": "Auftragseingang Heute",
    "overview__today_margin": "Deckungsbeitrag Heute",
    "overview__today_order_count": "Aufträge Heute",
    "overview__yesterday": "Gestern",
    "section_title__revenue_invoiced": "Summe Umsatz (Fakturiert)",
    "section_title__margin_invoiced": "Deckungsbeitrag (Fakturiert)",
    "section_title__margin_order_sum": "Deckungsbeitrag (Auftragseingang)",
    "section_title__order_sum_total": "Summe Auftragseingang",
    "chart_label__last_year": "vom Vorjahresmonat",
    "analysis_section__ai_notice": "Empfohlene Kunden",
    "analysis_section__expansion_potential_title": "🚀 Größtes Ausbaupotenzial",
    "analysis_section__expansion_potential_subtitle": "Diese Kunden haben die höchsten absoluten Ausbaupotenziale",
    "analysis_section__revenue_decline_title": "⚠️ Höchste Abwanderungen",
    "analysis_section__revenue_decline_subtitle": "Diese Kunden haben die höchsten absoluten Abwanderungswarnungen",
    "analysis_section__show_all": "Alle anzeigen",
    "tab_title_order_overview__open_quotes": "Offene Angebote",
    "tab_title_order_overview__open_orders": "Offene Aufträge",
    "table_header__sales": "Umsatz",
    "overview__filter_billed": "Fakturiert",
    "activities__tasks_title_one": "Offene Aufgabe",
    "activities__tasks_title_other": "Offene Aufgaben",
    "activities__events_title_one": "Termin",
    "activities__events_title_other": "Termine",
    "activities__create_task": "Neue Aufgabe",
    "activities__create_event": "Neuer Termin",
    "activities__event_title": "Kundenbesuch",
    "dashboard__empty_state__title": "Nichts anstehend",
    "dashboard__empty_state__subtitle": "<0>Aufgabe</0> oder <1>Termin</1> hinzufügen",
    "dashboard__empty_state__subtitle_tasks_only": "<0>Aufgabe</0> hinzufügen",
    "analysis_section__snippets__revenue-delta": "{{revenueDelta, number}} Umsatz",
    "analysis_section__snippets__order-sum-delta": "{{revenueDelta, number}} Auftragseingang",
    "analysis_section__snippets__days-since-first-order": "{{days}}T seit erster Bestellung",
    "analysis_section__snippets__days-since-last-order": "{{days}}T seit letzter Bestellung",
    "analysis_section__snippets__open_quotes_one": "{{count}} offenes Angebot",
    "analysis_section__snippets__open_quotes_other": "{{count}} offene Angebote",
    "analysis_section__snippets__cross_sell_one": "{{count}}x Cross-Sell",
    "analysis_section__snippets__cross_sell_other": "{{count}}x Cross-Sell",
    "analysis_section__snippets__share_of_wallet_one": "{{count}}x Umsatzpotenzial nicht ausgeschöpft",
    "analysis_section__snippets__share_of_wallet_other": "{{count}}x Umsatzpotenzial nicht ausgeschöpft",
    "analysis_section__snippets__first_purchase_one": "{{count}}x Erstkauf",
    "analysis_section__snippets__first_purchase_other": "{{count}}x Erstkauf",
    "analysis_section__snippets__churn_warning_one": "{{count}}x Abwanderung",
    "analysis_section__snippets__churn_warning_other": "{{count}}x Abwanderung",
    "snippet_sales_insights_one": "{{count}} Empfehlung",
    "snippet_sales_insights_other": "{{count}} Empfehlungen",
    "analysis_section__show_dormant_customers": "Ruhende Kunden anzeigen",
    "chart_tabs__metric_label": "Kennzahl"
}
